export const LOGINFO_LOCALSTORAGE_KEY = '@NAV/logInfo'
